import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MealModel } from 'src/app/nutrigenic/models/home/meal-model';
import { PlanService } from 'src/app/nutrigenic/services/plan/plan.service';
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResizeDetectionService } from "../../../services/resize-detection.service";
import { PlanOrderDetailModel } from 'src/app/nutrigenic/models/plan/plan-order-detail-model';

@Component({
    selector: 'app-select-meals',
    templateUrl: './select-meals.component.html',
    styleUrls: ['./select-meals.component.scss']
})
export class SelectMealsComponent {

    isTablet: boolean = false;
    isMobile: boolean = false;
    isDesktop: boolean = false;
    loading: boolean = true;
    
    subTotal: number = 0;
    subTotalS: string = "0";
    count: number = 0;
    diff_meals: number = 0;
    diff_meals_array: any = [];
    tot_meals_array: any = [];
    meals_per_day_array: any = [];
    selectedMealsTrigger: boolean = false;
    amountTrigger: boolean = false;
    maxSameMealTypeCount: number = 5; // max amount of same meal
    
    
    selectedCategories: number[];
    allergies: any[] = [];
    allergens: any[] = [];
    selectedTag: number = 0;
    search: string = '';
    searchIcon = true;
    allMeals: MealModel[] = [];
    selectedMealsGrid: boolean[] = [];
    oneWeekMeals: MealModel[] = [];
    planOrderDetails: PlanOrderDetailModel = new PlanOrderDetailModel();
    discount: number = 0;
    promo_discount: number = 0;
    promo_discount_object: any = null;
    deliveryFees: number = 3.95;
    singleDeliveryPrice: number = 3.95;
    visualMeals: any = [];
    cart: any = [];
    


    constructor(
        private sizedetection: ResizeDetectionService,
        private planService: PlanService,
        private spinner: NgxSpinnerService,
        private router: Router
    ) { }




    ngOnInit() {

        // Size Detection
        this.sizedetection.refreshSize();
        this.sizedetection.sizeCondition$.subscribe(data => {
            this.isDesktop = data.isDesktop;
            this.isTablet = data.isTablet;
            this.isMobile = data.isMobile;
        });

        

        this.planOrderDetails = this.getFromLocalStorage('orderDetails');
        this.cart = this.getFromLocalStorage('cart');
        //console.log(this.planOrderDetails);

        this.selectedTag = this.planOrderDetails.goal;
        this.selectedCategories = this.planOrderDetails.categories;

        if (localStorage.getItem('promo_discount')) {
            let promo_discount: any = localStorage.getItem('promo_discount');
            this.promo_discount = parseFloat(promo_discount);
            this.discount = this.promo_discount;
            //console.log(this.promo_discount);
        } 
        
        if (localStorage.getItem('promo_discount_object')) {
            this.promo_discount_object = localStorage.getItem('promo_discount_object');
            this.promo_discount_object = JSON.parse(this.promo_discount_object);
            let promo_discount: any = this.promo_discount_object.discount.firstWeekDiscount;
            this.promo_discount = parseFloat(promo_discount);
            this.discount = this.promo_discount;
            //console.log(this.promo_discount);
        }

        this.getMeals(this.planOrderDetails.allergies);

        // this should be returned by the backend
        this.deliveryFees = (this.planOrderDetails.dayPerWeek == 3 ? 1 : 2) * this.singleDeliveryPrice;

        if (this.promo_discount_object && this.promo_discount_object.free_shipping_type) {
            this.deliveryFees = 0;
        }
    }

    getFromLocalStorage(localStorageProperty: string) {
        let localStorageObject:any = localStorage.getItem(localStorageProperty);
        if (!localStorageObject) {
            let error = {
                error: {
                    message: 'No plan details found'
                }
            }
            this.handleError(error);
            this.router.navigate(['/order-flow']);
        }
        return JSON.parse(localStorageObject);
    }


    getExpectedMealsTotalCount() {
        return this.getExpectedMealsWeeklyTotalCount() * this.planOrderDetails.weeks;
    }

    getExpectedMealsWeeklyTotalCount() {
        return this.planOrderDetails.mealPerDay * this.planOrderDetails.dayPerWeek;
    }

    calcoloQuantita() {
        // Calcolo quantità
        this.count = this.planService.countTotalMeals(this.oneWeekMeals);
        this.diff_meals = this.getExpectedMealsWeeklyTotalCount() - this.count;
        this.tot_meals_array = [];

        for (let index = 0; index < this.planOrderDetails.mealPerDay; index++) {
            this.meals_per_day_array.push(1);
        }

        for (let index = 0; index < this.planOrderDetails.dayPerWeek; index++) {
            this.tot_meals_array.push(1);
        }
        this.diff_meals_array = [];
        for (let index = 0; index < this.diff_meals; index++) {
            this.diff_meals_array.push(1);
        }
    }


    getSelectedMealsRows(): boolean[][] {
        const rows = [];
        for (let i = 0; i < this.selectedMealsGrid.length; i += this.planOrderDetails.dayPerWeek) {
            rows.push(this.selectedMealsGrid.slice(i, i + this.planOrderDetails.dayPerWeek));
        }
        return rows;
    }


    getMeals(allergies: any = [], tags: any = [], mealCategories: any = []) {

        this.spinner.show('mealsSpinner');

        // use the preferences to filter out the meals and store them into visualMeals
        this.planService.getMeals(allergies, tags, mealCategories).subscribe({
            next: (meals: MealModel[]) => {

                this.oneWeekMeals = this.cart[0];
                this.allMeals = JSON.parse(JSON.stringify(meals)); // deep cloning the list
                this.visualMeals = meals;

                this.updateMealsOnPage();

                this.loading = false;
                this.calcoloQuantita();

                this.selectedMealsGrid = this.populateSelectedMealsGrid(this.getExpectedMealsWeeklyTotalCount(), this.planService.countTotalMeals(this.oneWeekMeals));

                this.spinner.hide('mealsSpinner');
            },
            error: (error) => {
                this.spinner.hide('mealsSpinner');
                this.handleError(error);
            }
        });
    }

    populateSelectedMealsGrid(totalMealsPerWeek: number, totalSelectedMeals: number){
        const result = [];
        for (let i = 0; i < totalMealsPerWeek; i++) {
            result.push(i < totalSelectedMeals);
        }
        return result;
    }


    onMealsSearchChange(filteredMeals: MealModel[]){
        this.visualMeals = JSON.parse(JSON.stringify(filteredMeals)); // deep cloning the list // reset the meals to original list so that i can apply the changes from oneWeekMeals
        this.updateMealsOnPage();
    }


    resetSearch() {
        this.visualMeals = JSON.parse(JSON.stringify(this.allMeals)); // deep cloning the list // reset the meals to original list so that i can apply the changes from oneWeekMeals
        this.updateMealsOnPage();
    }


    handleError(error: any): void {
        error = error.message ?? 'Internal error - Could not complete the operation';
        Notify.failure(error, {
            position: 'right-top',
            timeout: 3000
        });
    }

    updateMealsOnPage(){
        this.oneWeekMeals.forEach((meal: MealModel) => {
            this.visualMeals.forEach((item: MealModel) => {
                if(meal.id == item.id) {
                    item.isAdded = meal.isAdded;
                    item.count = meal.count;
                    item.show_nutrients = meal.show_nutrients;
                } 
            });
        });

        this.selectedMealsGrid = this.populateSelectedMealsGrid(this.getExpectedMealsWeeklyTotalCount(), this.planService.countTotalMeals(this.oneWeekMeals));
    }

    decreaseCount(meal: MealModel) {
        this.oneWeekMeals.forEach((item: MealModel) => {
            if (item.id == meal.id) {
                if (item.count == 1) {
                    this.removeMeal(meal);
                } else item.count = item.count - 1
            }
        });
        this.subTotal = 0;
        this.oneWeekMeals.forEach((added: any) => {
            if (added.isAdded == true)
                this.subTotal += added.price * added.count;
        });
        this.calcoloQuantita();
        this.updateMealsOnPage();
    }

    increaseCount(meal: MealModel) {
        if (this.planService.countTotalMeals(this.oneWeekMeals) >= this.getExpectedMealsWeeklyTotalCount()) {
            let error: any = {
                "message": 'You reached the max amount of meals for your plan!'
            }
            this.handleError(error);
        } else {
            this.oneWeekMeals.forEach((item: MealModel) => {
                if (item.id == meal.id) {
                    if(item.count == this.maxSameMealTypeCount){
                        let error: any = {
                            "message": 'Cannot add more meals of this type'
                        }
                        this.handleError(error);
                    } else {
                        item.count = item.count + 1;
                    }
                    
                }
            });
            this.subTotal = 0;
            this.oneWeekMeals.forEach((added: any) => {
                if (added.isAdded == true)
                    this.subTotal += added.price * added.count;
            });
            this.calcoloQuantita();
            this.updateMealsOnPage();
        }
    }

    removeMeal(meal: MealModel) {
        const mealToRemove = this.visualMeals.find((item: any) => item.id == meal.id);
        if (mealToRemove) {
            mealToRemove.count = 0;
            mealToRemove.isAdded = false;
            mealToRemove.show_nutrients = true;
        }
        this.oneWeekMeals = this.oneWeekMeals.filter((item: any) => item.id !== meal.id);
        this.calcoloQuantita();
        this.updateMealsOnPage();
    }

    addMeal(meal: MealModel) {
        if (this.getTotalElements() >= this.getExpectedMealsWeeklyTotalCount()) {
            let error: any = {
                "message": 'Cannot add more meals'
            }
            this.handleError(error);
        } else {
            meal.isAdded = true;
            meal.count = 1;
            meal.show_nutrients = false;
            this.oneWeekMeals.push(meal);
            this.updateMealsOnPage();
            
        }
    }

    showCheckoutDetails(item: string) {
        switch (item) {
            case 'selectedMeals': this.selectedMealsTrigger = !this.selectedMealsTrigger; break;
            case 'amount': this.amountTrigger = !this.amountTrigger; break;
        }
    }

    getSubTotal() {
        let total = 0;
        this.oneWeekMeals.forEach((meal: any) => {
            if (meal.isAdded == true)
                total += meal.price * meal.count;
        });

        return Number(total).toFixed(2);
    }

    getTotal() {
        let total = Number(this.getSubTotal());

        total = total - (total * this.discount / 100);
        total = total + this.deliveryFees;//- this.promo_discount;
        return Number(total).toFixed(2);
    }

    getDiscount() {
        let total = Number(this.getSubTotal());

        //console.log(total)
        if (this.planOrderDetails.type != 'Flexi') {
            return Number(total * this.discount / 100).toFixed(2);
        } else {
            return Number(total * this.discount / 100).toFixed(2);//this.promo_discount;
        }
    }

    goToCart() {
        let cart: MealModel[][] = [];
        for(let i = 0; i < this.planOrderDetails.weeks; i++){
            cart[i] = JSON.parse(JSON.stringify(this.oneWeekMeals));
        }
        localStorage.setItem('cart', JSON.stringify(cart));

        localStorage.removeItem('order_id');
        localStorage.removeItem('order');
        localStorage.removeItem('payment_intent_id');

        this.router.navigate(['/order-summary']);
    }



    getTotalElements() {
        let total_elements = 0;
        this.oneWeekMeals.forEach((meal: any) => {
            if (meal.isAdded == true) {
                total_elements += meal.count;
            }
            
        })
        return total_elements;
    }

    getTotalElementsWeek() {
        let total_elements = 0;
        if (this.oneWeekMeals.length > 0)
            this.oneWeekMeals.forEach((all: any) => {
                if (all.isAdded == true) {
                    total_elements += all.count;
                }
            })
        //console.log(total_elements)
        return total_elements;
    }


    getSubTotalVisual() {
        let total = 0;
        this.oneWeekMeals.forEach((added: any) => {
            if (added.isAdded == true)
                total += added.price * added.count;
        });

        //total = total - (total * this.discount / 100);
        //total = total + this.deliveryFees ;//- this.promo_discount;
        return Number(total).toFixed(2);
    }

    getDiscountVisual() {
        let total = 0;
        this.oneWeekMeals.forEach((added: any) => {
            if (added.isAdded == true)
                total += added.price * added.count;
        });

        total = total * this.discount / 100;
        //total = total + this.deliveryFees ;//- this.promo_discount;
        return Number(total).toFixed(2);
    }

    getTotalVisual() {
        let total = 0;
        if (this.oneWeekMeals.length > 0)
            this.oneWeekMeals.forEach((added: any) => {
                if (added.isAdded == true)
                    total += added.price * added.count;
            });

        total = total - (total * this.discount / 100);
        total = total + this.deliveryFees;//- this.promo_discount;
        return Number(total).toFixed(2);
    }

    getDeliveries() {
        if (this.planOrderDetails.dayPerWeek) {
            return (this.planOrderDetails.dayPerWeek == 3 ? 1 : 2);//* this.planOrderDetails.weeks;
        } else return 1;
    }

    getDiscountFirst() {
        let total = 0;
        if (this.oneWeekMeals.length > 0)
            this.oneWeekMeals.forEach((all: any) => {
                if (all.isAdded == true)
                    total += all.price * all.count;
            });

        return Number(total * this.discount / 100).toFixed(2);
    }



}


